/****** choose diamond function ********/
$(document).on("click", ".chooseDiamondLink", function() {
    $('#choose_diamond').addClass('choose_diamond_spinner');

    var diamond_id = $(this).data("diamondid");

    var productSku = []; 
    var proceedFlag = 1;
    jQuery.getJSON('/cart.js', function(cart) {
      if(cart.items != ''){ 
        
        $(cart.items).each(function(index, value) { 
           var str = "-";   
           var sku = value.sku;
  
           if(sku.indexOf(str) != -1){                  
             sku = sku.split('-');
             sku = sku[1];                       
           }else{
             var sku = value.sku;      
           }
                     
           if(sku == diamond_id){
             $('#choose_diamond').removeClass('choose_diamond_spinner');
             proceedFlag = 0;
             event.preventDefault();            
             alert("Product already in cart. Please change diamond.");            
           }                              
         });       
      }
    });
  
    var diamond = [{
        
        "diamond_id": $(this).data("diamondid"),
        "d1diamond_id":$(this).data("d1diamondid"),
        "d2diamond_id":$(this).data("d2diamondid"),
        "diamond_certno": $(this).data("certno"),
        "diamond_shape": $(this).data("shape"),
        "diamond_price": $(this).data("price"),
        "diamond_name": $(this).data("name"),
        "diamond_type": $(this).data("type"),
        "size" : $(this).data("carat"),
        "diamond_image": $(this).data("image"),
    }];

    setTimeout(function(){        
   
      if(proceedFlag == 1){   
        localStorage.setItem("earring_diamond", JSON.stringify(diamond));
        localStorage.setItem('disable_earring_add_to_cart' , 0);
        setSteps("diamond");
        $('#choose_diamond').removeClass('choose_diamond_spinner');
  
      }     
      
   }, 800);
  
  // window.location.href = "/collections/ring-builder-engagement-rings-1";
});
/****** end of choose diamond *****/

/******* Choose Setting function start ******/
$(document).on("click", ".choose-setting", function() {      
  $("#choose_setting").addClass("choose_setting_spinner");

  var selected_diamond = localStorage.getItem("earring_diamond");

  if(selected_diamond != null || selected_diamond != undefined){
    var earring_selected_shape = $("#center_stone").val();
    selected_diamond = JSON.parse(selected_diamond);
    var selected_shape = selected_diamond[0].diamond_shape;
    
    if(selected_shape != earring_selected_shape){     
      alert("Selected diamond can not match with earring, please change the diamond");     
      
      $("#choose_setting").removeClass("choose_setting_spinner");
      return false;
    }
  }
  
    var setting = [{
        "product_id": $("#product_id").val(),
        "product_handel": $("#product_handel").val(),
        "setting_id": $("#variant_id").val(),
        "setting_name": $("#variant_name").val(),
        "setting_price": $("#variant_price").val(),
        "setting_metal_type": $("#setting_metal_type").val(),
        "setting_sku": $("#variant_sku").val(),
        "setting_url": $("#variant_url").val(),
      	// "setting_chainlength": $("#SingleOptionSelector-0").val(),
        "stock_num": $("#stock_num").val(),
        "minimum_carat_total_weight": $("#minimum_carat_total_weight").val().replace('ct','').trim(),
        "maximum_carat_total_weight": $("#maximum_carat_total_weight").val().replace('ct','').trim(),
        "setting_type": $("#setting_type").val(),
        "center_stone": $("#center_stone").val(),
        "can_be_match_with": $("#can_be_match_with").val(),
      	"image": $("#stockimg0").attr("src"),
      	"setting_style": $("#setting_style").val(),
        "setting_description":$("#product_description").val(),
        "setting_metafields":$("#product_metafields").val(),
        "setting_media_image_id":$("#varient_media_id").val(),
        "setting_image":$("#setting_image").val(),
        "new_setting_style":$("#new_setting_style").val(),
    }];
    localStorage.setItem("earring_setting", JSON.stringify(setting));
    localStorage.setItem('disable_earring_add_to_cart' , 0);
    $("#choose_setting").removeClass("choose_setting_spinner");
    setSteps("setting");
});
/******* Choose Setting function end  ******/


/*** set currenct step and redirect to next step start ****/
function setSteps(current_step) {

    if (localStorage.getItem("earring_setting") && localStorage.getItem("earring_diamond")) {
        localStorage.setItem("earring_step3", "final earring");
        var setting_info = JSON.parse(localStorage.getItem("earring_setting"));      
        var diamond_info = JSON.parse(localStorage.getItem("earring_diamond"));
        
      	var diamond_price = (diamond_info[0].diamond_price);      	    
        var final_price = parseInt(setting_info[0].setting_price/100) + diamond_price; 
        localStorage.setItem("final_earring_price", final_price);
        
        var diamond_id = diamond_info[0].diamond_id;
        var setting_id = setting_info[0].product_handel;
        var varient_id = setting_info[0].setting_id;
        window.location.href = tps_config.urls.earring_builder_final_page+"?setting_select=true&diamond_select=true?products="+diamond_id+"/"+setting_id+"/"+varient_id; // "/pages/final-earring";

    } else if (current_step == "diamond" && localStorage.getItem("earring_setting")) {
        localStorage.setItem("earring_step2", "diamond");
        window.location.href = tps_config.urls.earring_builder_final_page+"?setting_select=true&diamond_select=true" // "/pages/final-earring";
    } else if (current_step == "setting" && localStorage.getItem("earring_diamond")) {
        localStorage.setItem("earring_step2", "setting");
        window.location.href = tps_config.urls.earring_builder_final_page+"?setting_select=true&diamond_select=true" //"/pages/final-earring";
    } else if (current_step == "diamond" && !localStorage.getItem("earring_setting")) {
        localStorage.setItem("earring_step1", "diamond");
        localStorage.setItem("earring_step2", "setting");
        window.location.href = tps_config.urls.earring_builder_listing+"?setting_select=true" //tps_config.urls.earring_builder_listing+"";
    } else if (current_step == "setting" && !localStorage.getItem("earring_diamond")) {
      	localStorage.setItem("earring_step1", "setting");
        localStorage.setItem("earring_step2", "diamond");
        window.location.href = tps_config.urls.earringbuilder_loose_diamond+"?diamond_select=true"  //tps_config.urls.earringbuilder_loose_diamond+"";
    }


}
/*** set currenct step and redirect to next step end ****/


$(document).ready(function() {
  
  if((getQueryVariable('diamond_select') || getQueryVariable('setting_select') || getQueryVariable('id') || getQueryVariable('diamond_id') || window.location.pathname.indexOf('products') > -1  ) ){
   
  }else{
    if(localStorage.getItem("earring_setting") || localStorage.getItem("earring_diamond")){
    	localStorage.removeItem("earring_diamond");
        localStorage.removeItem("earring_setting");
        localStorage.removeItem("final_earring_price");
        localStorage.removeItem("earringbuilder_dia_shape");
        localStorage.removeItem("earring_step1");
        localStorage.removeItem("earring_step2");
        localStorage.removeItem("earring_step3");
    
      	window.location.href = tps_config.urls.earring_builder_listing;
    }
   
  }
    // window.location.href = "/collections/ring-builder-engagement-rings-1";
});
/*** set currenct step and redirect to next step end ****/

function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i=0;i<vars.length;i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  } 
  return false;
}

 $(document).ready(function() {
      var currencyCode = "{{ cart.currency.iso_code }}";
      var currencySymbol = getCurrenySymbol(currencyCode);
   
      /*** set last updated timestamp of product collection if local storage has 1 hour old product collection then clear collection ****/
      if (localStorage.getItem("earring_last_updated")) {
          var d1 = new Date();
          var d2 = new Date(localStorage.getItem("earring_last_updated"));
          var diff = parseInt(((d1 - d2) / 1000).toString());
          if (diff > 3600) {
              localStorage.clear();
              localStorage.setItem("earring_last_updated", d1);
          }

      } else {
          localStorage.setItem("earring_last_updated", new Date());
      }

      /**** set steps and render steps data start *****/
      var active = '';
      var first_step = '';
      var second_step = '';
      if ((localStorage.getItem("earring_step1") == null && localStorage.getItem("earring_step2") == null) && (window.location.pathname.indexOf('/products/') == 0 || window.location.pathname.indexOf('/collections/') == 0)) {
          active = "setting";
          first_step = "setting";
          second_step = "diamond"; 
      } else if ((localStorage.getItem("earring_step1") == null && localStorage.getItem("earring_step2") == null) && (window.location.pathname.indexOf('/pages/') == 0)) {
          active = "diamond";
          first_step = "diamond";
          second_step = "setting"; 
      } else if ((localStorage.getItem("earring_step1") && (localStorage.getItem("earring_step1") == "diamond"))) {
          first_step = "diamond";
          second_step = "setting"; 
      } else if ((localStorage.getItem("earring_step1") && (localStorage.getItem("earring_step1") == "setting"))) {
          first_step = "setting";
          second_step = "diamond"; 
      }
      if (active == '') {
        if (window.location.pathname.indexOf('/products/') == 0 || window.location.pathname.indexOf('/collections/') == 0) {
          active = "setting";
        } else if (window.location.pathname.indexOf('final-earring') > -1) {
          active = "final";
        } else {
          active = "diamond";
        }

      }

      //dynamically steps text changes  
      if (first_step == "setting") {
          if(jQuery(window).width() <= 767){
              //in mobile step text changes
              $("#step1").html("Setting");
              $("#step2").html("Diamonds");
              $("#step3").html("Complete Earring");
              //end
          }else{
            $("#step1").html("Choose Your Setting");          
            $("#step2").html("Choose Your Diamonds");
          }
          $(".step1").addClass("setting-step");
          $(".step2").addClass("diamond-step");
          $(".step_imgs1").addClass("ring_img");
          $(".step_imgs2").addClass("diamond_img");                   
          
      } else {
        if(jQuery(window).width() <= 767){
          //in mobile step text changes
          $("#step2").html("Setting");
          $("#step1").html("Diamonds");
          $("#step3").html("Complete Earring");
          //end
        }else{
          $("#step2").html("Choose Your Setting");
          $("#step1").html("Choose Your Diamonds");
        }
          
          $(".step1").addClass("diamond-step");
          $(".step2").addClass("setting-step");
          $(".step_imgs2").addClass("ring_img");
          $(".step_imgs1").addClass("diamond_img");
          
      }
      //end
   
      if (first_step == "diamond" && localStorage.getItem("earring_diamond")) {         
          var diamond_info = JSON.parse(localStorage.getItem("earring_diamond"));
          var dia_price = diamond_info[0].diamond_price;
          var dia_type = diamond_info[0].diamond_type;
        
          $("#step1_price").html(''+currencySymbol+''+addCommas(dia_price));
          $("#step1_view_href").attr("href", tps_config.urls.earringbuilder_loose_diamond_detail+"?diamond_id="+diamond_info[0].diamond_id+"&diamond_type="+dia_type);
          if(dia_type == 'lab'){            
            $("#step1_change_href").attr("href", tps_config.urls.earringbuilder_lab_diamond+"?diamond_select=true");
          }else{
            $("#step1_change_href").attr("href", tps_config.urls.earringbuilder_loose_diamond+"?diamond_select=true");
          }
        
          $(".step1_details").show();
          $("#diamond_type_wrap .white_select").attr("href", tps_config.urls.earringbuilder_loose_diamond+"?diamond_select=true");
          $("#diamond_type_wrap .lab_select").attr("href", tps_config.urls.earringbuilder_lab_diamond+"?diamond_select=true");
      } else if (second_step == "diamond" && localStorage.getItem("earring_diamond")) {        
          var diamond_info = JSON.parse(localStorage.getItem("earring_diamond"));    
          var dia_price = diamond_info[0].diamond_price;
          var dia_type = diamond_info[0].diamond_type;
        
          $("#step2_price").html(''+currencySymbol+''+addCommas(dia_price));   
          $("#step2_view_href").attr("href", tps_config.urls.earringbuilder_loose_diamond_detail+"?diamond_id=" + diamond_info[0].diamond_id+"&diamond_type="+dia_type);
          if(dia_type == 'lab'){            
            $("#step2_change_href").attr("href", tps_config.urls.earringbuilder_lab_diamond+"?diamond_select=true");
          }else{            
            $("#step2_change_href").attr("href", tps_config.urls.earringbuilder_loose_diamond+"?diamond_select=true");
          }
        
          $(".step2_details").show();
      }

      if (first_step == "setting" && localStorage.getItem("earring_setting")) {      
          var setting_info = JSON.parse(localStorage.getItem("earring_setting"));
         $("#step1_price").html(''+currencySymbol+''+addCommas(setting_info[0].setting_price/100));
          $("#step1_view_href").attr("href", setting_info[0].setting_url);
          $(".step1_details").show();
          $("#step1_change_href").attr("href", tps_config.urls.earring_builder_listing+"?setting_select=true");
      } else if (second_step == "setting" && localStorage.getItem("earring_setting")) {         
          var setting_info = JSON.parse(localStorage.getItem("earring_setting"));
          $("#step2_price").html(''+currencySymbol+''+addCommas(setting_info[0].setting_price/100));
          $("#step2_view_href").attr("href", setting_info[0].setting_url);
          $("#step2_change_href").attr("href", tps_config.urls.earring_builder_listing+"?diamond_select=true");
          $(".step2_details").show();
      }
      $("." + active + "-step").addClass("active");
      if (window.location.pathname.indexOf('final-earring') > -1) {
        $(".diamond-step").addClass("active");
        $(".setting-step").addClass("active");
      }
      if (localStorage.getItem("final_earring_price")) { 
         $("#step3_price").html(''+currencySymbol+''+addCommas(localStorage.getItem("final_earring_price")));        
      }
      if (localStorage.getItem("earring_diamond") && localStorage.getItem("earring_setting")) {
          var setting_info = JSON.parse(localStorage.getItem("earring_setting"));
          var diamond_info = JSON.parse(localStorage.getItem("earring_diamond"));    
          var diamond_id = diamond_info[0].diamond_id;
          var setting_id = setting_info[0].product_handel;
          var varient_id = setting_info[0].setting_id;
        
          var final_view_button_url = tps_config.urls.earring_builder_final_page+"?setting_select=true&diamond_select=true?products="+diamond_id+"/"+setting_id+"/"+varient_id; // "/pages/final-earring";
          if(first_step == 'diamond'){
            $(".tps_reset_filter_diamond").show();
            $(".tps_reset_filter_setting").remove();
          }else{
            $(".tps_reset_filter_diamond").remove();
          }  
          $("#step3_view_href").attr("href", final_view_button_url);        
          $(".step3_details").show();
      }




  });
/**** set steps and render steps data end *****/

/**** Earring builder flow start over start *****/
function startOver(step){

  var setting_product_min_price = localStorage.getItem("earring_setting_min_price");
  var setting_product_max_price = localStorage.getItem("earring_setting_max_price");
  
  localStorage.removeItem("earring_diamond");
  localStorage.removeItem("earring_setting");
  localStorage.removeItem("final_earring_price");
  localStorage.removeItem("earringbuilder_dia_shape");
    localStorage.removeItem("earringbuilder_dia_shape");
    localStorage.removeItem("earringbuilder_dia_color");
    localStorage.removeItem("earringbuilder_min_carat");
    localStorage.removeItem("earringbuilder_max_carat");
   localStorage.removeItem("earringbuilder_max_symmetry");
   localStorage.removeItem("earringbuilder_min_symmetry");
   localStorage.removeItem("earringbuilder_min_table");
    localStorage.removeItem("earringbuilder_max_table");
    localStorage.removeItem("earringbuilder_min_clarity");
  localStorage.removeItem("earringbuilder_dia_clarity"); 
   localStorage.removeItem("earringbuilder_dia_cut"); 
  localStorage.removeItem("earringbuilder_dia_polish"); 
   localStorage.removeItem("earringbuilder_dia_symmetry"); 
    localStorage.removeItem("earringbuilder_dia_fluorescence");
   localStorage.removeItem("earringbuilder_min_price");
  localStorage.removeItem("earringbuilder_max_price");
   localStorage.removeItem("earring_setting_selected_shape");
   localStorage.removeItem("earringbuilder_max_depth");
  localStorage.removeItem("earringbuilder_min_depth");
   localStorage.removeItem("earringbuilder_lab");
 
  localStorage.removeItem("earringbuilder_recent_ids");  
  localStorage.removeItem("earring_setting_shape_fillter");  
  localStorage.removeItem("earring_setting_metal_fillter");
  localStorage.removeItem("earring_setting_style_fillter");  
  localStorage.setItem("earring_setting_price_from", setting_product_min_price);
  localStorage.setItem("earring_setting_price_to", setting_product_max_price);
  localStorage.removeItem("earring_step1");
  localStorage.removeItem("earring_step2");
  localStorage.removeItem("earring_step3");
  if(step == 'setting'){
      window.location.href = tps_config.urls.earring_builder_listing+"";
  }else{
      window.location.href = tps_config.urls.earringbuilder_loose_diamond+"";
  }
}
/**** Earring builder flow start over end *****/